import React from 'react';
import PropTypes from 'prop-types';

function Button({ text, className, onclickfun, disabled = false }) {
  // const returnFunction = (e)=>{
  //     e.preventDefault();
  //     let timer;
  //     clearTimeout(timer);

  //     // Set a new timer to trigger the action after a delay
  //     timer = setTimeout(() => {
  //       // Action to perform after the delay (e.g., showing an alert)
  //       return onclickfun(e)
  //     }, 3000);

  // }
  return (
    <button className={className} onClick={(e) => onclickfun(e)} disabled={disabled}>
      {disabled ? 'Loading.....' : text}
    </button>
  );
}

Button.propTypes = {
  text: PropTypes.node,
  className: PropTypes.string,
  onclickfun: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default Button;
